import { XCircle, BrainCircuit, Compass } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const pains = [
  {
    icon: Compass,
    title: "Manca un metodo strategico",
    text: "Tante idee, nessun processo per validarle e trasformarle in un modello di business che regge davvero.",
  },
  {
    icon: BrainCircuit,
    title: "L'IA resta un punto interrogativo",
    text: "Sai che serve, ma non come usarla in modo produttivo e concreto nella tua impresa.",
  },
  {
    icon: XCircle,
    title: "Nessuno che ti accompagna",
    text: "Costruire da soli è lento e fragile. Serve chi ti sfida, ti guida e ti mette alla prova.",
  },
];

export const Problem = () => (
  <section id="problema" className="relative bg-white py-24 sm:py-32" data-testid="problem-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <Overline>Il problema</Overline>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-5 max-w-3xl font-display text-4xl font-black uppercase leading-[0.98] tracking-tight text-[#16256B] sm:text-5xl lg:text-6xl">
          Avere un&rsquo;idea non basta.
          <br />
          <span className="text-[#C9A227]">Serve un metodo.</span>
        </h2>
      </Reveal>

      <div className="mt-16 grid gap-6 md:grid-cols-3">
        {pains.map((p, i) => (
          <Reveal
            key={p.title}
            delay={i * 0.12}
            className="group rounded-2xl border border-[#E4E8F2] bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:border-[#16256B]/25 hover:shadow-[0_20px_50px_-20px_rgba(22,37,107,0.35)]"
            data-testid={`pain-point-${i}`}
          >
            <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#16256B]/5">
              <p.icon className="h-6 w-6 text-[#16256B]" strokeWidth={1.75} />
            </span>
            <h3 className="mt-6 font-display text-xl font-extrabold text-[#16256B]">
              {p.title}
            </h3>
            <p className="mt-3 font-body text-sm leading-relaxed text-[#4A5268]">
              {p.text}
            </p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
